import { Injectable } from '@angular/core';
import { IProject } from '../interfaces/IProject';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IProjectLocation } from '../interfaces/IProjectLocation';
import { IProjectContractStage } from '../interfaces/IProjectContractStage';
import { IProjectContract } from '../interfaces/IProjectContract';
import { IProjectOperatingCompany } from '../interfaces/IProjectOperatingCompany';
import { IEquipmentData } from '../interfaces/IEquipmentData';
import { IProjectRelatedProject } from '../interfaces/IProjectRelatedProject';
import { IProjectLink } from '../interfaces/IProjectLink';


@Injectable({
  providedIn: 'root'
})
export class ProjectDataService {


  // project$: Observable<IProject>;

  constructor(public httpClient: HttpClient) {  }

  getProject(projectID: number): Observable<IProject> {

    let project$ = this.httpClient.get(`/api/project/${projectID}`) as Observable<IProject>;

    return project$;
  }


  getLocations(projectId: number): Observable<IProjectLocation[]> {
    let projectLocations$ = this.httpClient.get(`/api/project/${projectId}/projectlocations`) as Observable<IProjectLocation[]>;

    return projectLocations$;
  }

  getOperatingCompanies(projectId: number): Observable<IProjectOperatingCompany[]> {
    let operatingCompanies$ = this.httpClient.get(`/api/project/${projectId}/operatingcompanies`) as Observable<IProjectOperatingCompany[]>;

    return operatingCompanies$;
  }

  getProjectContracts(projectId: number): Observable<IProjectContract[]> {
    let projectContracts$ = this.httpClient.get(`/api/project/${projectId}/projectcontracts`) as Observable<IProjectContract[]>;

    return projectContracts$;
  }

  getProjectContractStages(projectId: number): Observable<IProjectContractStage[]> {
    let projectContractStages$ = this.httpClient.get(`/api/project/${projectId}/projectcontracts`) as Observable<IProjectContractStage[]>;

    return projectContractStages$;
  }

  getAssetContractors(projectId: number): Observable<any[]> {
    let assetContractors$ = this.httpClient.get(`/api/project/${projectId}/assetcontractors`) as Observable<any[]>;

    return assetContractors$;
  }
  getAssetOperator(projectId: number): Observable<any> {
    let assetOperator$ = this.httpClient.get(`/api/project/${projectId}/assetoperator`) as Observable<any>;

    return assetOperator$;
  }

  getAssetRelatedProjects(assetId: number) {
    let assetRelatedProjects$ = this.httpClient.get(`/api/asset/${assetId}/relatedprojects`) as Observable<any>;

    return assetRelatedProjects$;
  }

  getProjectRelatedProjects(projectId: number): Observable<IProjectRelatedProject[]> {
    return this.httpClient.get<any[]>(`/api/project/${projectId}/projectRelatedProjects`).pipe(
      map(relatedProjects => (relatedProjects || []).map(relatedProject => ({
        projectID: relatedProject.relatedProjectProjectID,
        projectName: relatedProject.relatedProjectProjectName,
        updated: relatedProject.updated,
        displayOrder: relatedProject.displayOrder,
        highlightDate: relatedProject.highlightDate
      })))
    );
  }

  getProjectLinks(projectId: number): Observable<IProjectLink[]> {
    return this.httpClient.get<any[]>(`/api/project/${projectId}/projectLinks`).pipe(
      map(links => (links || []).map(link => ({
        url: link.projectLinkURL,
        text: link.projectLinkText,
        updated: link.updated
      })))
    );
  }


  // this.http.get<any>(`/projects/${projectId}/equipment`)
  getProjectEquipment(projectId: number): Observable<IEquipmentData> {

    return this.httpClient.get<IEquipmentData>(`/api/projects/${projectId}/equipment`);

    // return sample data...
    return of({
      //// Electrical Cables needs more workF
      // "electricalCables": [
      //   {
      //     "electricalCurrentType": "AC",
      //     "lengthKm": 50,
      //     "voltageKv": 220,
      //     "isOnshore": true,
      //     "isOffshore": false
      //   },
      //   {
      //     "electricalCurrentType": "DC",
      //     "lengthKm": 75,
      //     "voltageKv": 400,
      //     "isOnshore": false,
      //     "isOffshore": true
      //   },
      //   {
      //     "electricalCurrentType": "AC",
      //     "lengthKm": 100,
      //     "voltageKv": 330,
      //     "isOnshore": true,
      //     "isOffshore": true
      //   },
      //   {
      //     "electricalCurrentType": "DC",
      //     "lengthKm": 120,
      //     "voltageKv": 500,
      //     "isOnshore": false,
      //     "isOffshore": true
      //   },
      //   {
      //     "electricalCurrentType": "AC",
      //     "lengthKm": 80,
      //     "voltageKv": 275,
      //     "isOnshore": true,
      //     "isOffshore": false
      //   }
      // ],
      "tidalTurbines": [
        {
          "type": "Type A",
          "minNumberOfTurbines": 5,
          "exactNumberOfTurbines": null,
          "maxNumberOfTurbines": 10,
          "deviceCapacity": 1.5,
          "foundationType": "Type A Foundation"
        },
        {
          "type": "Type B",
          "minNumberOfTurbines": null,
          "exactNumberOfTurbines": 8,
          "maxNumberOfTurbines": null,
          "deviceCapacity": 2.0,
          "foundationType": "Type B Foundation"
        },
        {
          "type": "Type C",
          "minNumberOfTurbines": 3,
          "exactNumberOfTurbines": null,
          "maxNumberOfTurbines": 7,
          "deviceCapacity": 1.8,
          "foundationType": "Type C Foundation"
        },
        {
          "type": "Type D",
          "minNumberOfTurbines": null,
          "exactNumberOfTurbines": 6,
          "maxNumberOfTurbines": null,
          "deviceCapacity": 2.5,
          "foundationType": "Type D Foundation"
        },
        {
          "type": "Type E",
          "minNumberOfTurbines": 4,
          "exactNumberOfTurbines": null,
          "maxNumberOfTurbines": 9,
          "deviceCapacity": 2.2,
          "foundationType": "Type E Foundation"
        }
      ],
      // "compressors": [],
      "solar": {
        "solarPVTypes": [
          {
            "description": "Monocrystalline Silicon"
          },
          {
            "description": "Polycrystalline Silicon"
          },
          {
            "description": "Thin-Film Solar Cells"
          }
        ],
        "solarCSPTypes": [
          {
            "description": "Parabolic Trough"
          },
          {
            "description": "Solar Power Tower"
          },
          {
            "description": "Linear Fresnel Reflector"
          }
        ]
      },
      "waveDevices": [
        {
          "deviceType": "Type A",
          "minNumberOfDevices": 5,
          "exactNumberOfDevices": null,
          "maxNumberOfDevices": 10,
          "deviceCapacity": 1.5,
          "isOnshore": true,
          "isOffshore": false,
          "foundationOrMooringType": "Type A Foundation"
        },
        {
          "deviceType": "Type B",
          "minNumberOfDevices": null,
          "exactNumberOfDevices": 8,
          "maxNumberOfDevices": null,
          "deviceCapacity": 2.0,
          "isOnshore": false,
          "isOffshore": true,
          "foundationOrMooringType": "Type B Foundation"
        },
        {
          "deviceType": "Type C",
          "minNumberOfDevices": 3,
          "exactNumberOfDevices": null,
          "maxNumberOfDevices": 7,
          "deviceCapacity": 1.8,
          "isOnshore": true,
          "isOffshore": true,
          "foundationOrMooringType": "Type C Foundation"
        },
        {
          "deviceType": "Type D",
          "minNumberOfDevices": null,
          "exactNumberOfDevices": 6,
          "maxNumberOfDevices": null,
          "deviceCapacity": 2.5,
          "isOnshore": false,
          "isOffshore": true,
          "foundationOrMooringType": "Type D Foundation"
        },
        {
          "deviceType": "Type E",
          "minNumberOfDevices": 4,
          "exactNumberOfDevices": null,
          "maxNumberOfDevices": 9,
          "deviceCapacity": 2.2,
          "isOnshore": true,
          "isOffshore": false,
          "foundationOrMooringType": "Type E Foundation"
        }
      ],
      "plant": [
        {
          "plantType": "Type A",
          "dailyProcessCapacity": 1000,
          "annualProcessCapacity": 365000,
          "productionUnits": [
            {
              "productionUnitType": "Unit A1"
            },
            {
              "productionUnitType": "Unit A2"
            }
          ],
          "materials": [
            {
              "material": "Material A1"
            },
            {
              "material": "Material A2"
            }
          ]
        },
        {
          "plantType": "Type B",
          "dailyProcessCapacity": 2000,
          "annualProcessCapacity": 730000,
          "productionUnits": [
            {
              "productionUnitType": "Unit B1"
            }
          ],
          "materials": [
            {
              "material": "Material B1"
            }
          ]
        },
        {
          "plantType": "Type C",
          "dailyProcessCapacity": null,
          "annualProcessCapacity": 500000,
          "productionUnits": [
            {
              "productionUnitType": "Unit C1"
            }
          ],
          "materials": [
            {
              "material": "Material C1"
            }
          ]
        },
        {
          "plantType": "Type D",
          "dailyProcessCapacity": 1500,
          "annualProcessCapacity": null,
          "productionUnits": [
            {
              "productionUnitType": "Unit D1"
            },
            {
              "productionUnitType": "Unit D2"
            }
          ],
          "materials": [
            {
              "material": "Material D1"
            }
          ]
        },
        {
          "plantType": "Type E",
          "dailyProcessCapacity": 2500,
          "annualProcessCapacity": 912500,
          "productionUnits": [
            {
              "productionUnitType": "Unit E1"
            }
          ],
          "materials": [
            {
              "material": "Material E1"
            },
            {
              "material": "Material E2"
            }
          ]
        }
      ],
      "surf": {
        "subseaTrees": [
          {
            "type": "Tree Type A",
            "count": 5
          },
          {
            "type": "Tree Type B",
            "count": 3
          },
          {
            "type": "Tree Type C",
            "count": 7
          }
        ],
        "umbilicals": [
          {
            "type": "Umbilical Type A",
            "length": 10
          },
          {
            "type": "Umbilical Type B",
            "length": 15
          },
          {
            "type": "Umbilical Type C",
            "length": 20
          }
        ],
        "risers": [
          {
            "type": "Riser Type A",
            "length": 500
          },
          {
            "type": "Riser Type B",
            "length": 750
          },
          {
            "type": "Riser Type C",
            "length": 1000
          }
        ],
        "flowlines": [
          {
            "type": "Flowline Type A",
            "fluid": "Oil",
            "length": 20.5,
            "diameter": 8
          },
          {
            "type": "Flowline Type B",
            "fluid": "Gas",
            "length": 30.0,
            "diameter": 10
          },
          {
            "type": "Flowline Type C",
            "fluid": "Water",
            "length": 25.0,
            "diameter": 12
          }
        ]
      },
      "hydrogenCapacity": {
        "powerInput": 100,
        "production": 5000,
        "capacity": 6000,
        "ammoniaCapacity": 3000
      },

      // "emissionSystems": [],
      // "manifolds": [],
      //"gasProcessing": [],
      // "geothermal": [],
      // "drillingFacilities": [],
      // "vessels": [],
      // "aluminiumFacility": [],
      // "capexPackages": [],


      // "ccsTechnology": {
      //   "type": "Type A",
      //   "subType": "SubType A",
      //   "hasPipeline": true,
      //   "hasTanker": false,
      //   "ccsStorageStructures": [
      //     {
      //       "type": "Structure A1",
      //       "capacity": 1000,
      //       "injectionRate": 50
      //     },
      //     {
      //       "type": "Structure A2",
      //       "capacity": 2000,
      //       "injectionRate": 100
      //     }
      //   ]
      // }, 
      // "terminals": [
      //   {
      //     "terminalType": "LNG",
      //     "terminalFuels": [
      //       {
      //         "material": "Natural Gas",
      //         "annualCapacity": 500000,
      //         "annualRateUnit": "tons",
      //         "processingUnitType": "Cryogenic"
      //       }
      //     ]
      //   },
      //   {
      //     "terminalType": "Oil",
      //     "terminalFuels": [
      //       {
      //         "material": "Crude Oil",
      //         "annualCapacity": 1000000,
      //         "annualRateUnit": "barrels",
      //         "processingUnitType": "Distillation"
      //       }
      //     ]
      //   },
      //   {
      //     "terminalType": "LNG",
      //     "terminalFuels": [
      //       {
      //         "material": "Natural Gas",
      //         "annualCapacity": 750000,
      //         "annualRateUnit": "tons",
      //         "processingUnitType": "Cryogenic"
      //       }
      //     ]
      //   },
      //   {
      //     "terminalType": "Oil",
      //     "terminalFuels": [
      //       {
      //         "material": "Crude Oil",
      //         "annualCapacity": 1200000,
      //         "annualRateUnit": "barrels",
      //         "processingUnitType": "Distillation"
      //       }
      //     ]
      //   },
      //   {
      //     "terminalType": "LNG",
      //     "terminalFuels": [
      //       {
      //         "material": "Natural Gas",
      //         "annualCapacity": 600000,
      //         "annualRateUnit": "tons",
      //         "processingUnitType": "Cryogenic"
      //       }
      //     ]
      //   }
      // ],
      // "powerCapacity": {
      //     "powerOutput": 900,
      //     "thermalOutput": 500,
      //     "powerCapacity": 1800,
      //     "batteryType": "Sodium-sulfur"
      // },
      // "powerFuelTypes": [
      //     {
      //         "powerFuelType": "Solar",
      //         "technologyTypes": ["Photovoltaic", "Concentrated Solar Power"]
      //     },
      //     {
      //         "powerFuelType": "Wind",
      //         "technologyTypes": ["Onshore Wind Turbines", "Offshore Wind Turbines"]
      //     },
      //     {
      //         "powerFuelType": "Hydro",
      //         "technologyTypes": ["Run-of-the-River", "Reservoir", "Pumped Storage"]
      //     },
      //     {
      //         "powerFuelType": "Biomass",
      //         "technologyTypes": ["Direct Combustion", "Gasification", "Anaerobic Digestion"]
      //     },
      //     {
      //         "powerFuelType": "Geothermal",
      //         "technologyTypes": ["Dry Steam", "Flash Steam", "Binary Cycle"]
      //     }
      // ],
      // "windTurbines": [
      //     {
      //         "windTurbineType": "Horizontal Axis",
      //         "minNumberOfTurbines": 5,
      //         "maxNumberOfTurbines": 10,
      //         "exactNumberOfTurbines": null,
      //         "height": 100,
      //         "hubHeight": 80,
      //         "bladeLength": 50,
      //         "deviceCapacity": 2.5,
      //         "offshoreWindFoundationType": "Monopile",
      //         "manufacturer": "Siemens"
      //     },
      //     {
      //         "windTurbineType": "Vertical Axis",
      //         "minNumberOfTurbines": null,
      //         "maxNumberOfTurbines": 15,
      //         "exactNumberOfTurbines": null,
      //         "height": 120,
      //         "hubHeight": 90,
      //         "bladeLength": 60,
      //         "deviceCapacity": 3.0,
      //         "offshoreWindFoundationType": "Jacket",
      //         "manufacturer": "GE"
      //     },
      //     {
      //         "windTurbineType": "Horizontal Axis",
      //         "minNumberOfTurbines": 8,
      //         "maxNumberOfTurbines": null,
      //         "exactNumberOfTurbines": null,
      //         "height": 110,
      //         "hubHeight": 85,
      //         "bladeLength": 55,
      //         "deviceCapacity": 2.8,
      //         "offshoreWindFoundationType": "Floating",
      //         "manufacturer": "Vestas"
      //     },
      //     {
      //         "windTurbineType": "Vertical Axis",
      //         "minNumberOfTurbines": null,
      //         "maxNumberOfTurbines": null,
      //         "exactNumberOfTurbines": 12,
      //         "height": 130,
      //         "hubHeight": 95,
      //         "bladeLength": 65,
      //         "deviceCapacity": 3.5,
      //         "offshoreWindFoundationType": "Gravity Base",
      //         "manufacturer": "Nordex"
      //     },
      //     {
      //         "windTurbineType": "Horizontal Axis",
      //         "minNumberOfTurbines": 10,
      //         "maxNumberOfTurbines": 20,
      //         "exactNumberOfTurbines": null,
      //         "height": 140,
      //         "hubHeight": 100,
      //         "bladeLength": 70,
      //         "deviceCapacity": 4.0,
      //         "offshoreWindFoundationType": "Monopile",
      //         "manufacturer": "Suzlon"
      //     }
      // ],
      // "fieldTypes": [
      //     {
      //         "type": "Oil",
      //         "subType": "Light Crude",
      //         "production": 100000,
      //         "productionUnit": "barrels/day",
      //         "reserves": 5000000,
      //         "reservesUnit": "barrels",
      //         "life": 15
      //     },
      //     {
      //         "type": "Gas",
      //         "subType": "Natural Gas",
      //         "production": 200000,
      //         "productionUnit": "cubic meters/day",
      //         "reserves": 10000000,
      //         "reservesUnit": "cubic meters",
      //         "life": 20
      //     },
      //     {
      //         "type": "Oil",
      //         "subType": "Heavy Crude",
      //         "production": 150000,
      //         "productionUnit": "barrels/day",
      //         "reserves": 7000000,
      //         "reservesUnit": "barrels",
      //         "life": 18
      //     },
      //     {
      //         "type": "Gas",
      //         "subType": "Shale Gas",
      //         "production": 250000,
      //         "productionUnit": "cubic meters/day",
      //         "reserves": 12000000,
      //         "reservesUnit": "cubic meters",
      //         "life": 25
      //     },
      //     {
      //         "type": "Oil",
      //         "subType": "Bitumen",
      //         "production": 80000,
      //         "productionUnit": "barrels/day",
      //         "reserves": 3000000,
      //         "reservesUnit": "barrels",
      //         "life": 10
      //     }
      // ],
      // "lngPlants": [
      //     {
      //         "lngPlantType": "Liquefaction Plant",
      //         "lngPlantFluids": [
      //             {
      //                 "fluidTypeID": 12,
      //                 "material": "Methane",
      //                 "annualCapacity": 5000000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 3
      //             },                      {
      //                 "fluidTypeID": 12,
      //                 "material": "Ethane",
      //                 "annualCapacity": 3000000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 2
      //             }
      //         ]
      //     },
      //     {
      //         "lngPlantType": "Regasification Plant",
      //         "lngPlantFluids": [
      //             {
      //                 "fluidTypeID": 12,
      //                 "material": "Ethane",
      //                 "annualCapacity": 3000000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 2
      //             }
      //         ]
      //     },
      //     {
      //         "lngPlantType": "Liquefaction Plant",
      //         "lngPlantFluids": [
      //             {
      //                 "fluidTypeID": 12,
      //                 "material": "Propane",
      //                 "annualCapacity": 4000000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 4
      //             }
      //         ]
      //     },
      //     {
      //         "lngPlantType": "Regasification Plant",
      //         "lngPlantFluids": [
      //             {
      //                 "fluidTypeID": 12,
      //                 "material": "Butane",
      //                 "annualCapacity": 3500000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 3
      //             }
      //         ]
      //     },
      //     {
      //         "lngPlantType": "Liquefaction Plant",
      //         "lngPlantFluids": [
      //             {
      //                 "fluidTypeID": 12,
      //                 "material": "Methane",
      //                 "annualCapacity": 6000000,
      //                 "annualRateUnit": "tons",
      //                 "trains": 5
      //             }
      //         ]
      //     }
      // ],
      // "pipelines": [
      //     {
      //         "fluidType": "Natural Gas",
      //         "isOnshore": true,
      //         "isOffshore": false,
      //         "length": 120,
      //         "diameter": 36,
      //         "dailyCapacity": 500000,
      //         "dailyRateUnit": "cubic meters",
      //         "annualCapacity": 182500000,
      //         "annualRateUnit": "cubic meters"
      //     },
      //     {
      //         "fluidType": "Crude Oil",
      //         "isOnshore": false,
      //         "isOffshore": true,
      //         "length": 200,
      //         "diameter": 42,
      //         "dailyCapacity": 750000,
      //         "dailyRateUnit": "barrels",
      //         "annualCapacity": 273750000,
      //         "annualRateUnit": "barrels"
      //     },
      //     {
      //         "fluidType": "Refined Products",
      //         "isOnshore": true,
      //         "isOffshore": true,
      //         "length": 150,
      //         "diameter": 30,
      //         "dailyCapacity": 300000,
      //         "dailyRateUnit": "liters",
      //         "annualCapacity": 109500000,
      //         "annualRateUnit": "liters"
      //     }
      // ],
      // "platforms": [
      //     {
      //         "platformStructureType": "Fixed Platform",
      //         "platformTypes": ["Steel Jacket", "Concrete Gravity"],
      //         "count": 5
      //     },
      //     {
      //         "platformStructureType": "Compliant Tower",
      //         "platformTypes": ["Guyed Tower", "Seastar"],
      //         "count": 3
      //     },
      //     {
      //         "platformStructureType": "Semi-submersible",
      //         "platformTypes": ["Column Stabilized", "Tension Leg"],
      //         "count": 4
      //     },
      //     {
      //         "platformStructureType": "Spar Platform",
      //         "platformTypes": ["Classic Spar", "Truss Spar"],
      //         "count": 2
      //     },
      //     {
      //         "platformStructureType": "Floating Production System",
      //         "platformTypes": ["FPSO", "FSO"],
      //         "count": 6
      //     }
      // ],
      // "floatingUnits": [
      //     {
      //         "floatingUnitType": "FPSO",
      //         "vessel": "Vessel A",
      //         "vesselStatus": "Active",
      //         "leaseStart": "2022-01-01T00:00:00Z",
      //         "leaseYears": 10,
      //         "leaseOptionalYears": 5,
      //         "fluids": [
      //             {
      //                 "material": "Oil",
      //                 "maxDailyCapacity": 100000,
      //                 "dailyRateUnit": "barrels",
      //                 "storageTotal": 2000000,
      //                 "storageUnit": "barrels"
      //             }
      //         ]
      //     },
      //     {
      //         "floatingUnitType": "FSO",
      //         "vessel": "Vessel B",
      //         "vesselStatus": "Inactive",
      //         "leaseStart": "2020-06-01T00:00:00Z",
      //         "leaseYears": 8,
      //         "leaseOptionalYears": 3,
      //         "fluids": [
      //             {
      //                 "material": "Gas",
      //                 "maxDailyCapacity": 50000,
      //                 "dailyRateUnit": "cubic meters",
      //                 "storageTotal": 1000000,
      //                 "storageUnit": "cubic meters"
      //             }
      //         ]
      //     },
      //     {
      //         "floatingUnitType": "FLNG",
      //         "vessel": "Vessel C",
      //         "vesselStatus": "Active",
      //         "leaseStart": "2021-03-01T00:00:00Z",
      //         "leaseYears": 12,
      //         "leaseOptionalYears": 4,
      //         "fluids": [
      //             {
      //                 "material": "LNG",
      //                 "maxDailyCapacity": 200000,
      //                 "dailyRateUnit": "tons",
      //                 "storageTotal": 4000000,
      //                 "storageUnit": "tons"
      //             }
      //         ]
      //     },
      //     {
      //         "floatingUnitType": "Drillship",
      //         "vessel": "Vessel D",
      //         "vesselStatus": "Under Maintenance",
      //         "leaseStart": "2019-09-01T00:00:00Z",
      //         "leaseYears": 7,
      //         "leaseOptionalYears": 2,
      //         "fluids": [
      //             {
      //                 "material": "Oil",
      //                 "maxDailyCapacity": 80000,
      //                 "dailyRateUnit": "barrels",
      //                 "storageTotal": 1600000,
      //                 "storageUnit": "barrels"
      //             }
      //         ]
      //     },
      //     {
      //         "floatingUnitType": "Semi-submersible",
      //         "vessel": "Vessel E",
      //         "vesselStatus": "Active",
      //         "leaseStart": "2023-05-01T00:00:00Z",
      //         "leaseYears": 15,
      //         "leaseOptionalYears": 5,
      //         "fluids": [
      //             {
      //                 "material": "Gas",
      //                 "maxDailyCapacity": 60000,
      //                 "dailyRateUnit": "cubic meters",
      //                 "storageTotal": 1200000,
      //                 "storageUnit": "cubic meters"
      //             }
      //         ]
      //     }
      // ],
      // "wells": [
      //     {
      //         "type": "Exploration",
      //         "count": 10
      //     },
      //     {
      //         "type": "Development",
      //         "count": 15
      //     },
      //     {
      //         "type": "Production",
      //         "count": 20
      //     },
      //     {
      //         "type": "Injection",
      //         "count": 5
      //     },
      //     {
      //         "type": "Abandoned",
      //         "count": 8
      //     }
      // ],
      // "processFacilities": [
      //     {
      //         "fluidType": "Oil",
      //         "capacity": 50000,
      //         "capacityUnit": "barrels/day",
      //         "terrain": "Onshore"
      //     },
      //     {
      //         "fluidType": "Gas",
      //         "capacity": 100000,
      //         "capacityUnit": "cubic meters/day",
      //         "terrain": "Offshore"
      //     },
      //     {
      //         "fluidType": "Water",
      //         "capacity": 20000,
      //         "capacityUnit": "cubic meters/day",
      //         "terrain": "Onshore"
      //     },
      //     {
      //         "fluidType": "LNG",
      //         "capacity": 30000,
      //         "capacityUnit": "tons/day",
      //         "terrain": "Offshore"
      //     },
      //     {
      //         "fluidType": "Condensate",
      //         "capacity": 40000,
      //         "capacityUnit": "barrels/day",
      //         "terrain": "Onshore"
      //     }
      //   ],

      // "storages": [
      //     {
      //         storageStructureType: 'Type A',
      //         material: 'Steel',
      //         capacity: 1000,
      //         capacityUnit: 'L'
      //     },
      //     {
      //         storageStructureType: 'Type B',
      //         material: 'Plastic',
      //         capacity: 500,
      //         capacityUnit: 'L'
      //     },
      //     {
      //         storageStructureType: 'Type C',
      //         material: 'Concrete',
      //         capacity: 2000,
      //         capacityUnit: 'L'
      //     },
      //     {
      //         storageStructureType: 'Type D',
      //         material: 'Wood',
      //         capacity: 750,
      //         capacityUnit: 'L'
      //     },
      //     {
      //         storageStructureType: 'Type E',
      //         material: 'Aluminum',
      //         capacity: 1200,
      //         capacityUnit: 'L'
      //     }
      // ],

    });
  }

}
